import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { useLanguage } from "@/hooks/useLanguage";

export default function Footer() {
  const { language } = useLanguage();
  const isEs = language === "es";

  const toolLinks = [
    { path: "/face-chart", label: "Face Chart" },
    { path: "/analyzer", label: isEs ? "Analizador" : "Analyzer" },
    { path: "/quiz", label: "Quiz" },
    { path: "/gallery", label: isEs ? "Galería" : "Gallery" },
  ];

  const contentLinks = [
    { path: "/blog", label: "Blog" },
    { path: "/history", label: isEs ? "Historia del Maquillaje" : "Makeup History" },
    { path: "/premium", label: "Premium" },
  ];

  const infoLinks = [
    { path: "/about", label: isEs ? "Sobre Nosotros" : "About Us" },
    { path: "/privacy", label: isEs ? "Privacidad" : "Privacy" },
    { path: "/terms", label: isEs ? "Términos y Condiciones" : "Terms & Conditions" },
    { path: "/cookies", label: isEs ? "Cookies" : "Cookies" },
    { path: "/support", label: isEs ? "Soporte y Contacto" : "Support & Contact" },
  ];

  return (
    <footer className="border-t border-border bg-card/50 mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-8 mb-10">
          {/* Brand */}
          <div className="col-span-2 sm:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-3">
              <Sparkles className="w-5 h-5 text-primary" />
              <span className="text-lg font-display font-bold text-gradient">glamcanva</span>
            </Link>
            <p className="text-foreground/70 text-sm leading-relaxed">
              {isEs
                ? "Generador de face chart gratis y analizador de maquillaje online."
                : "Free face chart generator and online makeup analyzer."}
            </p>
          </div>

          {/* Tools */}
          <div>
            <h3 className="text-foreground font-semibold text-sm mb-3">
              {isEs ? "Herramientas" : "Tools"}
            </h3>
            <ul className="space-y-2">
              {toolLinks.map(link => (
                <li key={link.path}>
                  <Link to={link.path} className="text-foreground/70 hover:text-primary text-sm transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Content */}
          <div>
            <h3 className="text-foreground font-semibold text-sm mb-3">
              {isEs ? "Contenido" : "Content"}
            </h3>
            <ul className="space-y-2">
              {contentLinks.map(link => (
                <li key={link.path}>
                  <Link to={link.path} className="text-foreground/70 hover:text-primary text-sm transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Info */}
          <div>
            <h3 className="text-foreground font-semibold text-sm mb-3">
              {isEs ? "Información" : "Info"}
            </h3>
            <ul className="space-y-2">
              {infoLinks.map(link => (
                <li key={link.path}>
                  <Link to={link.path} className="text-foreground/70 hover:text-primary text-sm transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-border pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground/60 text-xs">
            © {new Date().getFullYear()} glamcanva. {isEs ? "Todos los derechos reservados." : "All rights reserved."}
          </p>
          <div className="flex items-center gap-4 text-xs flex-wrap">
            <Link to="/privacy" className="text-foreground/60 hover:text-primary transition-colors">
              {isEs ? "Privacidad" : "Privacy"}
            </Link>
            <Link to="/terms" className="text-foreground/60 hover:text-primary transition-colors">
              {isEs ? "Términos" : "Terms"}
            </Link>
            <Link to="/cookies" className="text-foreground/60 hover:text-primary transition-colors">
              Cookies
            </Link>
            <Link to="/support" className="text-foreground/60 hover:text-primary transition-colors">
              {isEs ? "Contacto" : "Contact"}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
